import styled from 'styled-components';

import { BREAKPOINTS, colors } from 'common/styles/style-constants';
import { Alert } from 'opencare-crown';

export const InputWrapper = styled.div`
  position: relative;
`;

export const Input = styled.input`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.gray9};
  height: auto;
  width: 100%;
  padding: 24px 12px 10px;
  border-radius: 10px;
  box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid ${colors.gray6};
  word-break: normal;

  &:active,
  &:focus {
    border-color: ${colors.blue};
    box-shadow: 0 0 3px ${colors.blue};
    outline: none !important;
  }

  &:hover {
    border-color: ${colors.blue};
    box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.05);
  }

  &::placeholder {
    color: transparent;
  }
`;

export const Label = styled.label`
  color: ${colors.gray8};
  font-weight: 400;
  position: absolute;
  top: 18px;
  left: 12px;
  font-size: 16px;
  transition: transform 0.3s ease-in-out;
  background: 0;
  border: 0;
  outline: none;
  padding: 0;
  margin: 0;
  transform: ${(props) =>
    (props.hasText ? 'scale(0.8) translateX(-12%) translateY(-60%)' : null)};
`;

export const StyledAlert = styled(Alert)`
  && {
    margin-top: 10px;
  }
`;

export const CurrentLocationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    margin-top: 48px;
  }
`;

export const LoadingPartners = styled.div`
  text-align: center;
  font-size: medium;
`;
